export default __webpack_public_path__ + "static/media/unicef-logo1.4b82e76d.png";